import { useTheme } from '@mui/material/styles';
import { useCallback } from 'react';

import type { LegendExportConfig } from '../utils/svgLegend';

type SeriesLike = {
  name: string;
  iconType?: 'circle' | 'rect';
  color?: string;
}[];

export function useExportLegendConfig(params: {
  series: SeriesLike;
  colors: string[];
  isHidden: (name: string) => boolean;
  y: number;
}) {
  const theme = useTheme();
  const fontFamily = theme.typography.fontFamily;
  const textColor = theme.palette.text.primary;
  const { series, colors, isHidden, y } = params;

  return useCallback<() => LegendExportConfig>(() => {
    const items = series.map((s, i) => ({
      name: s.name,
      color: s.color || colors[i % colors.length],
      hidden: isHidden(s.name),
      iconType: s.iconType || 'circle',
    }));
    return {
      items,
      position: { y },
      fontFamily,
      textColor,
    };
  }, [series, colors, isHidden, y, fontFamily, textColor]);
}
